var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "orgBox2" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.navs.length,
            expression: "navs.length",
          },
        ],
        ref: "nav",
        staticClass: "nav",
      },
      _vm._l(_vm.navs, function (nav, i) {
        return _c(
          "span",
          {
            key: nav.value,
            class: { isSearch: nav.isSearch && !i },
            on: {
              click: function ($event) {
                return _vm.changeNav(nav, i)
              },
            },
          },
          [
            nav.isSearch && !i
              ? _c("i", { staticClass: "el-icon-search" })
              : _vm._e(),
            i ? _c("i", { staticClass: "el-icon-arrow-right" }) : _vm._e(),
            _vm._v(_vm._s(nav.text) + " "),
          ]
        )
      }),
      0
    ),
    _c(
      "div",
      {
        ref: "listBox",
        staticClass: "listBox",
        style: { height: _vm.listHeight },
      },
      [
        _vm.showList
          ? _c("orgList", {
              ref: "orgList",
              attrs: {
                "is-role": _vm.isRole,
                "is-search": _vm.isSearch,
                "search-keyword": _vm.realSearchKeyword,
                pid: _vm.pid,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }